(function () {
  const renderedPrices = new WeakMap();
  // Consume Hulk's calculated unit price; Shopify's cart JSON excludes these
  // draft-order option charges. Never sum the human-readable option labels.
  function moneyToCents(html) {
    if (typeof html !== 'string' || !html.trim()) return null;
    const element = document.createElement('span');
    element.innerHTML = html;
    let amount = element.textContent.replace(/[^\d.,-]/g, '');
    if (!/\d/.test(amount)) return null;
    const separator = Math.max(amount.lastIndexOf('.'), amount.lastIndexOf(','));
    const decimals = amount.length - separator - 1;
    if (separator >= 0 && decimals > 0 && decimals <= 2) {
      amount = amount.slice(0, separator).replace(/[.,]/g, '') + '.' + amount.slice(separator + 1);
    } else {
      amount = amount.replace(/[.,]/g, '');
    }
    const value = Number(amount);
    return Number.isFinite(value) ? Math.round(value * 100) : null;
  }

  function updateDrawer(drawer) {
    const calculatedItems = window.hulkapps?.discounts?.cart?.items || [];
    const prices = Array.from(drawer.querySelectorAll('[data-cart-option-price]'));
    const qualifyingPrices = [];
    let awaitingOptions = false;

    prices.forEach((element) => {
      const quantity = Number(element.dataset.quantity);
      const item = calculatedItems.find((item) => item.key === element.dataset.key);
      // Hulk's response need not contain quantity. Use the native line-price
      // integration, with cached output only for newly replaced sections.
      let formatted = item?.original_line_price_format;
      if (item && item.quantity == null) {
        // Only a unit price is safe to reuse across an unknown quantity.
        const unitPrice = moneyToCents(item.original_price_format);
        formatted = unitPrice !== null && typeof formatMoney === 'function' ?
          formatMoney(unitPrice * quantity, element.dataset.moneyFormat) : null;
      } else if (item && Number(item.quantity) !== quantity) {
        formatted = null;
      }
      const signature = item ? formatted + ':' + quantity : null;
      const previous = renderedPrices.get(element);
      if (formatted && previous !== signature && !element.dataset.hulkPriceReady) {
        const content = document.createElement('span');
        content.innerHTML = formatted;
        if (element.innerHTML !== content.innerHTML) element.innerHTML = content.innerHTML;
        element.dataset.hulkPriceReady = 'true';
      }
      renderedPrices.set(element, signature);
      // The store's currency converter preserves source-currency cents on the
      // money node. Use those for configured gift thresholds, not converted text.
      const sourceAmount = element.querySelector('.money')?.getAttribute(
        'doubly-currency-' + (element.dataset.shopCurrency || '').toLowerCase()
      );
      const linePrice = sourceAmount != null && sourceAmount !== '' && Number.isFinite(Number(sourceAmount)) ?
        Number(sourceAmount) : moneyToCents(element.innerHTML);
      const price = linePrice === null ? Number(element.dataset.basePrice) : Math.round(linePrice / quantity);
      if (element.dataset.giftEligible === 'true') {
        qualifyingPrices.push({ price, key: element.dataset.key, variantId: element.dataset.variantId });
        // Do not briefly recommend a lower gift while Hulk is still pricing options.
        if (element.dataset.hasOptions === 'true' && !element.dataset.hulkPriceReady &&
            price === Number(element.dataset.basePrice) && window.is_hulkpo_installed) {
          awaitingOptions = true;
        }
      }
    });

    drawer.querySelectorAll('[data-cart-tiered-gift]').forEach((container) => {
      const tiers = Array.from(container.querySelectorAll('template[data-gift-tier]'));
      const matchTier = (price) => tiers.find((template) => price >= Number(template.dataset.min) &&
        price < (template.dataset.max === '' ? Infinity : Number(template.dataset.max)));
      prices.forEach((element) => {
        const row = element.closest('[data-cart-line-key]');
        if (!row) return;
        const item = qualifyingPrices.find((item) => item.key === element.dataset.key);
        row.dataset.giftVariantId = !awaitingOptions && item ? matchTier(item.price)?.dataset.giftVariantId || '' : '';
      });
      const parent = qualifyingPrices.reduce((highest, item) => !highest || item.price > highest.price ? item : highest, null);
      const highestPrice = parent?.price;
      const tier = !awaitingOptions && qualifyingPrices.length ?
        matchTier(highestPrice) : null;
      // Match first, then suppress a gift already in the cart. Do not fall back
      // to another tier just because the matching gift has already been added.
      const selected = tier && tier.dataset.inCart !== 'true' ? tier : null;
      const result = container.querySelector('[data-gift-result]');
      const selectedTier = selected ? selected.dataset.giftTier : '';
      if (result.dataset.selectedTier !== selectedTier) {
        result.dataset.selectedTier = selectedTier;
        result.replaceChildren(...(selected ? [selected.content.cloneNode(true)] : []));
      }
      result.querySelectorAll('[data-cart-interval-gift="true"]').forEach((button) => {
        button.dataset.giftParentKey = parent.key;
        button.dataset.giftParentVariantId = parent.variantId;
      });
    });

    drawer.querySelectorAll('.product-recommendations-drawer').forEach((recommendations) => {
      recommendations.hidden = !recommendations.querySelector('.product-cart-item');
    });
  }

  function initialize() {
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer || drawer.dataset.optionPricesBound) return;
    drawer.dataset.optionPricesBound = 'true';
    let frame;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        updateDrawer(drawer);
      });
    };
    // Hulk rewrites the subtotal on every calculation. This also catches
    // asynchronous option edits and freshly rendered Shopify cart sections.
    new MutationObserver((records) => {
      records.forEach((record) => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        const price = target?.closest('[data-cart-option-price]');
        if (price) price.dataset.hulkPriceReady = 'true';
      });
      schedule();
    }).observe(drawer, {
      childList: true, subtree: true, characterData: true
    });
    document.addEventListener('cart-drawer:open', schedule);
    document.addEventListener('cart:item-added', schedule);
    document.addEventListener('line-item:change:end', schedule);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
